export default "__VITE_ASSET__77a657d9__"